import { render, staticRenderFns } from "./HomeBlog.vue?vue&type=template&id=3ddce8bc&name=home-blog&"
import script from "./HomeBlog.vue?vue&type=script&lang=js&"
export * from "./HomeBlog.vue?vue&type=script&lang=js&"
import style0 from "./HomeBlog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports